import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import {showBreedersApplication, changeApprovalStatus} from "../../../../actions/breeders"
import { NotificationManager } from "react-notifications";
import { Loader } from "../../../../components/loader";
import { BreadCrumb } from "../../../../components/breadcrumb";
import "react-phone-number-input/style.css";
import ImageViewer from 'react-simple-image-viewer';



const $ = window.$;

class ContractsView extends Component {
  constructor(props) {
    super(props);;
  }
  state = {  
    loading: false,
    breederApplicationInfo: { 
    BreederApplicationKennelImages : [],
    },
    isStatusChangeLoading : false,
    currentImage : 0,
    isViewerOpen : false,
    images: [],
  };

  componentDidMount() {    
    this.props.showBreedersApplication(this.props.match.params.id);  
    
  }

  componentWillReceiveProps = nextProps => {
   
    if (
      this.props.data.breederReducer.selectedBreederApplication !==
      nextProps.data.breederReducer.selectedBreederApplication
    ) {     
      let uploadedImages = nextProps.data.breederReducer.selectedBreederApplication.BreederApplicationKennelImages;
      let imageSourceArray = [];
      for(let item of uploadedImages ){
         let data =  `${process.env.REACT_APP_S3_PATH}/${item.image_path}`;
         imageSourceArray.push(data);
      }
      this.setState({
        breederApplicationInfo: nextProps.data.breederReducer.selectedBreederApplication, images : imageSourceArray, loading : false});  
    } 

    if (
      this.props.data.breederReducer.changedStatusApplication !==
      nextProps.data.breederReducer.changedStatusApplication
    ) {
        NotificationManager.success("Approval status changed successfully.");
        this.setState({isStatusChangeLoading: false });  
        $("#change_status_confirmation_modal").modal("hide");
        this.props.showBreedersApplication(this.props.match.params.id); 
    } 

    if (nextProps.data.breederReducer.changedStatusApplicationError &&
      this.props.data.breederReducer.changedStatusApplicationError !==
      nextProps.data.breederReducer.changedStatusApplicationError
    ) {
        NotificationManager.error("An error occurred while changing the approval status");
        this.setState({isStatusChangeLoading: false });  
        $("#change_status_confirmation_modal").modal("hide");
     
    } 

  }

  changeStatus = (e,status) => {
    e.preventDefault();
    if(status){
      this.setState({  status : 'approved' });
    }else{
      this.setState({ status : 'rejected' });
    }
    $("#change_status_confirmation_modal").modal("show");
  }

  submitStatusChange = (e) => {
    e.preventDefault();
    let data = {
      approval_status : this.state.status
    };
    this.setState({ isStatusChangeLoading : true });
    this.props.changeApprovalStatus(this.props.match.params.id, data);
  }

  openImageViewer = (index) => {
    this.setState({ currentImage : index, isViewerOpen : true });
  };

  closeImageViewer = () => {
    this.setState({ currentImage : 0, isViewerOpen : false });
  };
 
  items = [
    { title: "Breeders Applications", to: "/breeders/applications" },
    { title: "Breeder Application View", to: "/breeders/application/" + this.props.match.params.id }
  ];

  render() {
    const {     
      breederApplicationInfo,
      isStatusChangeLoading, 
      loading,    
      isViewerOpen,      
      currentImage,
      images,
    } = this.state;

    return (
      <div
        className="m-grid m-grid--hor m-grid--root m-page"
        style={{ minHeight: "100vh" }}
      >
      { !loading ?
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="row">
                <div className="col-lg-12">
                  <BreadCrumb items={this.items} />
                </div>              
              </div>      
              <div className="row justify-content-center"> 
                <div className="col-10">
                  <div className="m-portlet m-portlet--full-height ">                   
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{ boxShadow: "none" }}
                    >              
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">
                              Breeder Application Information
                            </h3>
                          </div>
                        </div>
                        <div className="m-portlet__head-tools">
                                  
                        </div>
                      </div>
                      <div className="m-portlet__body">
                      <div className="m-widget4">
                         <div className="row"> 
                         <strong>Breeder Info </strong>
                         </div>
                          <div className="row align-items-center mt-4">  
                            <div className="col-lg-6 col-sm-12"> 
                             <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                    <i className="fas fa-user mr-2"></i>
                                    <span className="pr-2">
                                     <strong>First Name:</strong>
                                    </span>
                                  { breederApplicationInfo.first_name }
                                </span>
                             </div>                                
                            </div>
                            <div className="col-lg-6 col-sm-12" >
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub">
                                        <i className="fas fa-user mr-2"></i>
                                        <span className="pr-2">
                                            <strong>Last Name:</strong>
                                        </span>
                                        {breederApplicationInfo.last_name }
                                        </span>
                                    </div>                     
                            
                            </div>
                            <div className="col-lg-6 col-sm-12" >
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub">
                                        <i className="fas fa-phone mr-2"></i>
                                        <span className="pr-2">
                                            <strong>Phone Number:</strong>
                                        </span>
                                          { breederApplicationInfo.phone }
                                        </span>
                                    </div>                     
                            
                            </div>
                            <div className="col-lg-6 col-sm-12" >
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub">
                                        <i className="fas fa-envelope mr-2"></i>
                                        <span className="pr-2">
                                            <strong>Email:</strong>
                                        </span>
                                          {breederApplicationInfo.email}
                                        </span>
                                    </div>                     
                            
                            </div>                      
                          </div>
                          <div class="m-separator m-separator--dashed m-separator--lg"></div>
                          <div className="row"> 
                           <strong>Breeder’s Information</strong>
                          </div>
                          <div className="row align-items-center mt-4">                   
                            <div className="col-lg-6 col-sm-12">
                               <div className="m-widget4__item">
                                   <span className="m-widget4__sub">
                                     <i className="fas fa-chevron-circle-right mr-2"></i>
                                    <span className="pr-2">
                                        <strong>Kennel Address:</strong>
                                    </span>
                                      {breederApplicationInfo.kennel_address}
                                    </span>
                                </div>                                
                            </div>
                            <div className="col-lg-6 col-sm-12" >
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-chevron-circle-right mr-2"></i>
                                  <span className="pr-2">
                                    <strong>Breeding License Number:</strong>
                                  </span>
                                   {breederApplicationInfo.breeding_license_number}
                                </span>
                              </div>                   
                     
                            </div>
                            <div className="col-lg-6 col-sm-12" >
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-chevron-circle-right mr-2"></i>
                                  <span className="pr-2">
                                    <strong>Years of Experience:</strong>
                                  </span>
                                   {breederApplicationInfo.yeas_of_breeding_experience}
                                </span>
                              </div>                     
                     
                            </div>
                            <div className="col-lg-6 col-sm-12" >
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-chevron-circle-right mr-2"></i> 
                                  <span className="pr-2">
                                    <strong>Which Breeds Do You Raise?:</strong>
                                  </span>
                                   {breederApplicationInfo.breeds_raise}
                                </span>
                              </div>                     
                     
                            </div>        
                            <div className="col-lg-6 col-sm-12" >
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-chevron-circle-right mr-2"></i>
                                  <span className="pr-2">
                                    <strong>List Any Professional Affiliations: </strong>
                                  </span>
                                 {breederApplicationInfo.professional_affiliations}
                                </span>
                              </div>                     
                     
                            </div>                                                   
                          </div>                          
                          <div class="m-separator m-separator--dashed m-separator--lg"></div>

                          <div className="row"> 
                           <strong>Breeding Practices</strong>
                          </div>
                          <div className="row align-items-center mt-4">                   
                            <div className="col-lg-6 col-sm-12">
                               <div className="m-widget4__item">
                                   <span className="m-widget4__sub">
                                     <i className="fas fa-chevron-circle-right mr-2"></i>
                                    <span className="pr-2">
                                       <strong>How Many Adult Females Do You Own?:</strong>
                                    </span>
                                    {breederApplicationInfo.number_of_adult_femails}
                                    </span>
                                </div>                                
                            </div>
                            <div className="col-lg-6 col-sm-12" >
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-chevron-circle-right mr-2"></i>
                                  <span className="pr-2">
                                    <strong>How Many Adult Males Do You Own?</strong>
                                  </span>
                                    {breederApplicationInfo.number_of_adult_males}
                                </span>
                              </div>                  
                            </div>
                            <div className="col-lg-6 col-sm-12" >
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-chevron-circle-right mr-2"></i>
                                  <span className="pr-2">
                                    <strong>How Often Do You Breed Your Females?:</strong>
                                  </span>
                                  {breederApplicationInfo.female_breed_period}
                                </span>
                              </div>                     
                     
                            </div>
                            <div className="col-lg-6 col-sm-12" >
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-chevron-circle-right mr-2"></i>
                                  <span className="pr-2">
                                    <strong>What is The Retirement Age for Your Female and Male Breeding Dogs?:</strong>
                                  </span>
                                   {breederApplicationInfo.retirement_age_of_female}
                                </span>
                              </div>                     
                     
                            </div>     
                            <div className="col-lg-6 col-sm-12" >
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-chevron-circle-right mr-2"></i>
                                  <span className="pr-2">
                                    <strong>What is The Retirement Age for Your Male Breeding Dogs?:</strong>
                                  </span>
                                   {breederApplicationInfo.retirement_age_of_male}
                                </span>
                              </div>                     
                     
                            </div>    
                            <div className="col-lg-6 col-sm-12" >
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-chevron-circle-right mr-2"></i>
                                  <span className="pr-2">
                                    <strong> How Often Do Your Breeding Dogs Get Health Checked by Your Veterinarian?:</strong>
                                  </span>
                                    {breederApplicationInfo.period_of_health_check}
                                </span>
                              </div>                     
                     
                            </div>
                            <div className="col-lg-6 col-sm-12" >
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-chevron-circle-right mr-2"></i>
                                  <span className="pr-2">
                                    <strong> How Many Vaccines Do Your Puppies Receive by 8 Weeks of Age?:</strong>
                                  </span>
                                    {breederApplicationInfo.number_of_vaccines_eight_weeks_age}
                                </span>
                              </div>                     
                     
                            </div>                                                  
                          </div>
                          <div class="m-separator m-separator--dashed m-separator--lg"></div>
                          <div className="row"> 
                           <strong>Business Practices and Ethics</strong>
                          </div>
                          <div className="row align-items-center mt-4">               
                            <div className="col-lg-6 col-sm-12" >
                                <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                    <i className="fas fa-chevron-circle-right mr-2"></i>
                                    <span className="pr-2">
                                    <strong>Describe the Health Guarantee Your Offer With Your Puppies:</strong>
                                    </span>
                                  {breederApplicationInfo.health_guarantee}
                                </span>
                                </div>                   

                            </div>
                            <div className="col-lg-6 col-sm-12" >
                                <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                    <i className="fas fa-chevron-circle-right mr-2"></i>
                                    <span className="pr-2">
                                    <strong>Which Other Online Puppy Platforms Do You Work With?:</strong>
                                    </span>
                                    {breederApplicationInfo.online_puppy_platforms}
                                </span>
                                </div>                   

                            </div>
                            <div className="col-lg-6 col-sm-12" >
                                <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                    <i className="fas fa-chevron-circle-right mr-2"></i>
                                    <span className="pr-2">
                                    <strong>Have You Ever Faced Any Legal or Ethical Issues Related to Breeding Practices or Animal Welfare? </strong>
                                    </span>
                                     {breederApplicationInfo.legal_or_ethical_issue_status ? "Yes":"No"}
                                     { breederApplicationInfo.legal_or_ethical_issue_status &&
                                     <>
                                     <br/>
                                     <span>
                                      {breederApplicationInfo.legal_or_ethical_issue_description}
                                     </span>
                                     </>
                                      }                               

                                </span>
                                </div>                

                            </div>                                                            
                          </div>
                          <div class="m-separator m-separator--dashed m-separator--lg"></div>

                          <div className="row"> 
                           <strong>Facility and Environment</strong>
                          </div>
                         <div className="row align-items-center mt-4">                 
                            <div className="col-lg-12 col-sm-12" >
                                <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                    <i className="fas fa-chevron-circle-right mr-2"></i>
                                    <span className="pr-2">
                                    <strong>Describe The Living Conditions and Environment of Your Kennel:</strong>
                                    </span>
                                    {breederApplicationInfo.living_conditions_and_environment}
                                </span>
                                </div>                   

                            </div>                                                                        
                         </div>  
                         <div class="m-separator m-separator--dashed m-separator--lg"></div>
                          <div className="row"> 
                            <strong>Images of Your Kennel</strong>
                          </div>   
                           <div className="row align-items-center mt-4">                   
                           { images.map((src, index) => (
                            <div className="col-lg-2 col-6" >                                            
                            <a
                             href="#"
                             onClick={ () => this.openImageViewer(index) }
                            >
                              <img
                                src={src}                                
                                width="125"
                                key={ index }
                                style={{ margin: '2px' }}
                                alt=""
                              />    
                            </a>                     
                            </div>   
                               ))}        
                              {isViewerOpen && (                              
                                <ImageViewer
                                  src={ images }
                                  currentIndex={ currentImage }
                                  disableScroll={ false }
                                  closeOnClickOutside={ true }
                                  onClose={ this.closeImageViewer }
                                />                             
                             )}                                                             
                         </div>                     
                          
                        </div>
                      </div>
                      <div className="m-portlet__foot">
                          <div className="row">
                            <div className="col-lg-12">                        
                                <div
                                  className="row"
                                  style={{ justifyContent: "flex-end" }}
                                >                            
                                   <div> 
                            
                                  {breederApplicationInfo.approval_status !== "rejected" &&
                                     <button
                                        type="button"
                                        onClick={(e) => this.changeStatus(e,false)}                              
                                        className="btn btn-danger m-btn--pill mx-2 mt-2"
                                      >                                        
                                        <span>
                                          &nbsp;&nbsp;
                                          <span>Reject</span>
                                          &nbsp;&nbsp;                               
                                        </span>
                                      </button>
                                       }
                                      {breederApplicationInfo.approval_status !== "approved" &&
                                      <button
                                        type="button"
                                        onClick={(e) => this.changeStatus(e,true)}                                    
                                        className="btn btn-primary m-btn--pill mx-2 mt-2"
                                      >
                                        <span>
                                          &nbsp;&nbsp;
                                          <span>Approve</span>
                                          &nbsp;&nbsp;                                     
                                        </span>
                                      </button> 
                                     }
                           
                                    </div>                                 
                                   
                             
                                </div>                                                   
                                
                            </div>
                          </div>
                      </div>     
                      {/* </div> */}
                    </div>

                  </div>
                </div>       
              </div>
            </div>
          </div>
        </div>:
        <div className={"loader-center"}>
          <Loader
            type="line-scale"
            active={true}
            className="loader-center"
          />
        </div>
      }
             {/* boost woo pet confirmation */}
             <div
                className="modal fade"
                id="change_status_confirmation_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="SectionSelectModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                          Change Approval Status
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                     Are you sure you want to change the approval status?
                    </div>

                    <div className="modal-footer">
                      {isStatusChangeLoading ? (
                        <Loader size={50} />
                      ) : (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            No
                          </button>
                          <button
                            type="button"
                            onClick={(e) => this.submitStatusChange(e)}
                            className="btn btn-primary m-btn--pill"
                          >
                            Yes
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* waybill section selelctor */}
    
      </div>
    );
  }
}

const mapStateToProps = state => ({
  petShop: state.petShopReducer,
  user: state.cognito.user,
  data: state,

});

const mapDispatchToProps = dispatch => ({
  showBreedersApplication: id => {
    dispatch(showBreedersApplication(id));
  },
  changeApprovalStatus : (id,data) => {
    dispatch(changeApprovalStatus(id,data));
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContractsView)
);
